module.exports = __webpack_public_path__ + "static/media/upload-pbcs.9b3e0263.mp4";